import React, { Component } from 'react';
import { LogOut } from 'lucide-react';
import { Auth } from '../../services';
import { APP_CONST } from '../../constants';
import { GeckoBtn } from '../../components';
import { $state } from '../../router/';

export class AppHeader extends Component {
    logout() {
        return $state.go('logout');
    }

    render() {
    	return (
    		<div className="app-header sticky top-0 z-10 w-full flex items-center bg-white border-b border-border py-3">
                <div className="w-full max-w-6xl mx-auto flex justify-between items-center px-3">
                    <div className="w-[120px]">
                        <img src="/images/gecko-engage-color.svg" alt="Gecko" height="22" />
                    </div>
                    <div className="flex items-center">
                        <HeaderButtons buttons={this.props.buttons} />
                        <GeckoBtn 
                            name="Logout" 
                            type={APP_CONST.BTN_TYPE_GHOST} 
                            size={APP_CONST.BTN_SIZE_SM}
                            handler={this.logout.bind(this)}
                            icon={LogOut}
                        />
                    </div>
                </div>
    		</div>
    	);
    }
}

AppHeader.defaultProps = {
    buttons: null,
}

const HeaderButtons = (props) => {
    if (!props.buttons || props.buttons.length === 0) return null;

    return (
        <>
            {props.buttons.map((button) => {
                return <GeckoBtn type={APP_CONST.BTN_TYPE_GHOST} size={APP_CONST.BTN_SIZE_SM} {...button}/>;
            })}
        </>
    )
}

HeaderButtons.defaultProps = {
    buttons: null,
}

export default AppHeader;